export function getFaviconMimeType(faviconPath: string): string {
  return faviconPath.toLowerCase().endsWith('.svg') ? 'image/svg+xml' : 'image/x-icon';
}

export function applyEnvironmentFavicon(faviconPath: string): void {
  if (!faviconPath) {
    return;
  }

  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');

  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.type = getFaviconMimeType(faviconPath);
  link.href = faviconPath;
}
